// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-table[data-v-7449459e]{width:100%;display:flex;flex-direction:column}.page-table-bottom[data-v-7449459e]{padding-top:4px;display:flex;align-items:center;justify-content:flex-end}.page-table-pagination[data-v-7449459e]{flex:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
